import {Tag} from "antd";
import styled from "styled-components";

export const StyledDATag = styled(Tag)`
	display: inline-flex;
	align-items: center;
	width: 100%;
	padding: var(--spacing-xs);
	min-width: 0;
	margin: 0;
	padding-right: var(--spacing-xs);

	.ant-tag-close-icon {
		margin-left: auto;
	}
`;

export const StyledDAContainer = styled.div`
	background-color: rgba(0, 0, 0, 0.05);
	padding: var(--spacing-sm);
	margin-bottom: var(--spacing-sm);
	border-radius: 6px;
	border: 1px solid #d9d9d9;

	.ant-list-item.ant-list-item-no-flex {
		padding: 0px 0px var(--spacing-xs);
		border: none;
	}
`